import styled from 'styled-components';

const FullWidthImageContainer = styled.div `
  position: relative;
  width: 100%;
  padding-bottom: ${props => Math.round((100 * 100) / props.ratio) / 100}%;
`;

export { FullWidthImageContainer as default };
//# sourceMappingURL=FullWidthImageContainer.mjs.map
